import {Button, Card, openDialog} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import {TimePickerShowcaseContent} from './TimePickerShowcaseContent';

export function TimePickerShowcase() {
  const handleOpen = () => {
    openDialog(<TimePickerShowcaseContent />, {
      title: 'TimePicker showcase',
      size: 'xLarge',
      scrollBehavior: 'inside',
      'data-testid': 'devSettings-timePickerShowcase',
    });
  };

  return (
    <Card title="TimePicker showcase" variant="inlineGrey">
      <VStack spacing={2}>
        <Button
          title="Open showcase"
          onClick={handleOpen}
          leftIcon="devices/access_time"
          variant="secondary"
          data-testid="devSettings-timePickerShowcase-openButton"
        />
        <Text size="xSmall" color="tertiary">
          The redesigned time field's new behavior in one place — flat rounded-time list, opening
          position, step intervals, free typing, and quick-time chips, on both TimePicker and
          DateTimePicker. Fully interactive with mocked local state.
        </Text>
      </VStack>
    </Card>
  );
}
